import $ from 'jquery';
import { utils } from '../common/utils';

export class DonationAmount {
    private $donationFlow: JQuery<HTMLElement>;
    private $amountcontrol: JQuery<HTMLElement>;
    private $presetamounts: JQuery<HTMLElement>;

    constructor(element: HTMLElement | JQuery<HTMLElement>) {
        this.$donationFlow = utils.isJquery(element) ? element : $(element);
        this.$amountcontrol = this.$donationFlow.find('.custom-amount');
        this.$presetamounts = this.$donationFlow.find("input[type='radio'][name='rbAmount']");
        this.initAmountEvents();
    }

    private initAmountEvents(): void {
        this.$amountcontrol.on('keypress click blur', () => {
            this.dispatchAmountChangedEvent();
        });

        this.$presetamounts.on('click', () => {
            this.$amountcontrol.val('');
            this.dispatchAmountChangedEvent();
        });
    }

    private dispatchAmountChangedEvent(): void {
        this.$donationFlow[0].dispatchEvent(new CustomEvent('amountchanged', { detail: { amount: this.getAmount() } }));
    }

    getAmount(): number {
        const amountval = this.$amountcontrol.val() as string;
        if (amountval) {
            this.$presetamounts.prop('checked', null);
            return parseInt(amountval);
        }

        const presetAmountVal = this.$donationFlow.find("input[type='radio'][name='rbAmount']:checked").val() as string;
        return presetAmountVal ? parseInt(presetAmountVal) : 0;
    }
}
